<div class="cf-dlg">

  <div class="cf-dlg-header">
    <div class="cf-dlg-icon cf-dlg-icon--red"><mat-icon>delete</mat-icon></div>
    <div>
      <h2 class="cf-dlg-title">Confirmar eliminación</h2>
      <p class="cf-dlg-subtitle">Esta acción no se puede deshacer</p>
    </div>
  </div>

  <div class="cf-dlg-body">
    <div style="display:flex;align-items:flex-start;gap:10px;padding:14px;background:#fef2f2;border:1px solid #fecaca;border-radius:8px">
      <mat-icon style="color:var(--cf-error,#dc2626);font-size:20px;width:20px;height:20px;flex-shrink:0;margin-top:1px">warning</mat-icon>
      <p style="margin:0;font-size:0.875rem;color:var(--cf-error,#dc2626);font-weight:500">{{ message }}</p>
    </div>
  </div>

  <div class="cf-dlg-footer">
    <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="closeDialog()">Cancelar</button>
    <button mat-flat-button class="cf-dlg-btn-danger" (click)="delete()">
      <mat-icon>delete</mat-icon> Eliminar
    </button>
  </div>

</div>
